import { GlobalStyles as BaseGlobalStyles } from '../ui/components/Globals/index';
import { Font } from './Font';

export function GlobalStyles() {
	return (
		<>
			<Font />
			<BaseGlobalStyles />
		</>
	);
}
